/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_Q_HintInputs */

const vi_shop_home_link_q_hint = /** @type {(inputs: Shop_Home_Link_Q_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web mở trang tìm kiếm với từ khoá này; Mini App mở màn tìm kiếm.`)
};

/**

* @param {Shop_Home_Link_Q_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_q_hint = /** @type {((inputs?: Shop_Home_Link_Q_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_Q_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_q_hint(inputs)
});